import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import i18n from "./plugins/i18n"
import axios from 'axios'
import axiosRetry from 'axios-retry';
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({ 
  routes: [], 
  mode:'history' 
});

axiosRetry(axios, {
  retries: 2,
  retryDelay: (retryCount) => {
    return retryCount * 500;
  },
  retryCondition: (error) => {
    return error.response.status === 503 ||
      error.response.status === 500 ||
      error.response.status === 400 ||
      error.response.status === 404 ||
      error.response.status === 401 
  },
});

Vue.config.productionTip = false;

new Vue({
  store,
  i18n,
  router,
  render: h => h(App)
}).$mount("#tripla-bwapp");
